import { Product } from "#interfaces/product/product.interface";
import { CommonModule } from "@angular/common";
import { Component, Inject, OnInit } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";

@Component({
    selector: "app-check-selected-dialog",
    imports: [CommonModule, MatIconModule, MatButtonModule],
    template: `
    <div class="flex flex-col gap-y-4">
      <div class="flex justify-between items-center flex-wrap">
        <h2 class="text-lg font-semibold">Productos seleccionados</h2>
        <div class="flex gap-x-4 items-center">
          <button
            (click)="closeModalWithData()"
            [disabled]="initialLength === data.products.length"
            type="submit"
            class="flex w-fit"
            mat-flat-button
            color="primary"
          >
            <span class=""> Confimar Cambios </span>
          </button>

          <button mat-icon-button color="warn" (click)="onNoClick()">
            <mat-icon class="fill-red-500 text-red-500">close</mat-icon>
          </button>
        </div>
      </div>
      <div class="w-full overflow-auto flex flex-col gap-y-3">
        <table class="w-full bg-card">
          <thead>
            <tr>
              <!-- <th>Codigo</th> -->
              <th>Nombre</th>
              <th>Categoria</th>
              <th>Subcategoria</th>
              <th>Stock</th>
              <th>Eliminar</th>
            </tr>
          </thead>
          <tbody *ngIf="data.products?.length > 0">
            <tr *ngFor="let product of data.products">
              <!-- <td>{{ product.code }}</td> -->
              <td>{{ product.name }}</td>
              <td>{{ product.subCategory.category.name }}</td>
              <td>{{ product.subCategory.name }}</td>
              <td>{{ product.currentStock | number }}</td>
              <td>
                <button mat-icon-button color="warn" (click)="deleteProduct(product)">
                  <mat-icon class="fill-red-500">delete</mat-icon>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  `,
    styles: [
        `
                     table {
                       @apply bg-card;
                     }
               
                     thead {
                       @apply dark:bg-card text-gray-500;
                     }
               
                     th {
                       @apply p-4 font-semibold text-md border-b-[1px] border-t-[1px];
                     }
               
                     td {
                       @apply p-4 font-normal border-b-[1px];
                     }
                   `,
    ]
})
export class CheckSelectedDialogComponent implements OnInit {
  initialLength: number;

  constructor(private dialogRef: MatDialogRef<CheckSelectedDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: { products: Product[] }) {}

  ngOnInit(): void {
    this.initialLength = this.data.products.length;
  }

  deleteProduct(product: Product) {
    this.data.products = this.data.products.filter((p) => p.id !== product.id);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  closeModalWithData() {
    this.dialogRef.close(this.data.products);
  }
}
